export const ultimasNoticias = [
    
    {
        "imagen" : "https://s-turismo.hidalgo.gob.mx/assets/imgs/tc1.jpg",
        "url" : "https://www.gob.mx/sectur/acciones-y-programas/resultados-a-la-convocatoria-participa-con-tu-proyecto-de-turismo-comunitario-para-formar-parte-de-la-guia-nacional-de-experiencias",
        "titulo" : "Resultados de la Convocatoria Turismo Comunitario",
        "fecha" : "Conoce los Proyectos por estado"
    },
    {
        "imagen" : "https://s-turismo.hidalgo.gob.mx/assets/imgs/galardon2025.jpg",
        "url" : "https://s-turismo.hidalgo.gob.mx/pdf/galardon2025.pdf",
        "titulo" : "Galardones a la Innovación Turística",
        "fecha" : "Convocatoria 3a Edición Finalizada"
    },
    {
        "imagen" : "https://s-turismo.hidalgo.gob.mx/assets/imgs/transpCorto2025.jpg",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/contraloriat/dir1/2025/48rubros/1erTrimestre/fraccion15a/TC_Conv%20Nal_HGO.pdf",
        "titulo" : "Concurso Nacional de Transparencia en Corto",
        "fecha" : "'Mecanismos de impulso a la transparencia para combatir la desinformación'"
    },
    {
        "imagen" : "https://s-turismo.hidalgo.gob.mx/assets/imgs/pcs2024.jpg",
        "url" : "https://hidalgo.travel/inicio/pueblos-con-sabor/",
        "titulo" : "Pueblos con Sabor",
        "fecha" : "Distintivo PCS 2025"
    },
    {
        "imagen" : "https://s-turismo.hidalgo.gob.mx/assets/imgs/tc.jpg",
        "url" : "https://s-turismo.hidalgo.gob.mx/pdf/convocatoriaTc.pdf",
        "titulo" : "Convocatoria Turismo Comunitario",
        "fecha" : "Finalizada"
    },
    {
        "imagen" : "https://s-turismo.hidalgo.gob.mx/assets/imgs/Tecozautla.jpg",
        "url" : "https://s-turismo.hidalgo.gob.mx/pdf/PueblosMagicos.pdf",
        "titulo" : "Pueblos Mágicos",
        "fecha" : ""
    }
    
]